module.exports = __webpack_public_path__ + "static/img/csv.a74b3e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/csv.png
// module id = 1Ent
// module chunks = 1